/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Compare_SubtitleInputs */

const en_landing_compare_subtitle = /** @type {(inputs: Landing_Compare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The difference between getting ghosted and getting interviews.`)
};

const de_landing_compare_subtitle = /** @type {(inputs: Landing_Compare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Unterschied zwischen Ghosting und Einladungen zum Vorstellungsgespraech.`)
};

const fr_landing_compare_subtitle = /** @type {(inputs: Landing_Compare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La différence entre se faire ghoster et décrocher des entretiens.`)
};

const es_landing_compare_subtitle = /** @type {(inputs: Landing_Compare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La diferencia entre que te ignoren y que te llamen a entrevista.`)
};

const it_landing_compare_subtitle = /** @type {(inputs: Landing_Compare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La differenza tra essere ignorato e ottenere un colloquio.`)
};

const nl_landing_compare_subtitle = /** @type {(inputs: Landing_Compare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het verschil tussen genegeerd worden en uitgenodigd worden voor gesprekken.`)
};

const pl_landing_compare_subtitle = /** @type {(inputs: Landing_Compare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Różnica między byciem ignorowanym a dostawaniem zaproszeń na rozmowy.`)
};

const fi_landing_compare_subtitle = /** @type {(inputs: Landing_Compare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ero siihen, jätetäänkö sinut huomiotta vai kutsutaanko haastatteluun.`)
};

const da_landing_compare_subtitle = /** @type {(inputs: Landing_Compare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forskellen mellem at blive ghostet og at komme til samtale.`)
};

const sv_landing_compare_subtitle = /** @type {(inputs: Landing_Compare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skillnaden mellan att bli ghostad och att få intervjuer.`)
};

/**
* | output |
* | --- |
* | "The difference between getting ghosted and getting interviews." |
*
* @param {Landing_Compare_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_compare_subtitle = /** @type {((inputs?: Landing_Compare_SubtitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Compare_SubtitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_compare_subtitle(inputs)
	if (locale === "fr") return fr_landing_compare_subtitle(inputs)
	if (locale === "es") return es_landing_compare_subtitle(inputs)
	if (locale === "it") return it_landing_compare_subtitle(inputs)
	if (locale === "nl") return nl_landing_compare_subtitle(inputs)
	if (locale === "pl") return pl_landing_compare_subtitle(inputs)
	if (locale === "fi") return fi_landing_compare_subtitle(inputs)
	if (locale === "da") return da_landing_compare_subtitle(inputs)
	if (locale === "sv") return sv_landing_compare_subtitle(inputs)
	return en_landing_compare_subtitle(inputs)
});